import { useContext } from "react";
import PaiementServices from "../services/paiementServices";
import { AuthContext } from "../contexts/AuthContext";

export default function usePaiement() {
  const { api } = useContext(AuthContext);
  const service = new PaiementServices(api);

  const getPaiements = async () => {
    return service.getAll();
  };

  const getPaiement = async (id) => {
    return service.getOne(id);
  };

  const updatePaiement = async (id, data) => {
    return service.update(id, data);
  };

  const paiementMvola = async (data) => {
    return service.paiementMvola(data);
  };

  const getMyPaiements = async (id) => {
    return service.getMyPaiements(id);
  };

  return {
    getPaiements,
    getPaiement,
    updatePaiement,
    paiementMvola,
    getMyPaiements,
  };
}
